import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

// ----- Lessons -----
export async function getLessons(track) {
  const { data } = await api.get(`/lessons/${track}`);
  return data;
}

// ----- Donations -----
export async function createDonationCheckout({ amount, origin_url }) {
  const { data } = await api.post(`/donations/checkout`, { amount, origin_url });
  return data;
}

export async function getDonationStatus(sessionId) {
  const { data } = await api.get(`/donations/status/${sessionId}`);
  return data;
}

// ----- Auth -----
export async function authCallback(session_id) {
  const { data } = await api.post(`/auth/callback`, { session_id });
  return data;
}

export async function getMe() {
  const { data } = await api.get(`/auth/me`);
  return data;
}

export async function logout() {
  const { data } = await api.post(`/auth/logout`);
  return data;
}

// ----- XP -----
export async function awardXp({ amount, source }) {
  const { data } = await api.post(`/xp/award`, { amount, source });
  return data;
}

export async function getLeaderboard(limit = 10) {
  const { data } = await api.get(`/xp/leaderboard?limit=${limit}`);
  return data;
}

// ----- Admin -----
export async function adminLogin(password) {
  const { data } = await api.post(`/admin/login`, { password });
  return data;
}

export async function adminLogout() {
  const { data } = await api.post(`/admin/logout`);
  return data;
}

export async function adminOverview() {
  const { data } = await api.get(`/admin/overview`);
  return data;
}
